import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { formatBytes } from '@/helpers/file'

interface Props {
  accept?: string
  maxFileSize?: number // en bytes
  dragDropText?: string
  fileTypesText?: string
  uploadStatusText?: string
  errorStatusText?: string
  errorMessage?: string
}

interface Emits {
  (e: 'fileSelected', file: File): void
  (e: 'fileRemoved'): void
  (e: 'uploadProgressComplete'): void
  (e: 'fileError', error: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUploaderComponent',
  props: {
    accept: { type: String, required: false, default: '.xlsx' },
    maxFileSize: { type: Number, required: false, default: 10 * 1024 * 1024 },
    dragDropText: { type: String, required: false, default: 'Arrastra un único documento o explora tu dispositivo' },
    fileTypesText: { type: String, required: false, default: 'Archivos válidos: .xlsx' },
    uploadStatusText: { type: String, required: false, default: 'Subiendo...' },
    errorStatusText: { type: String, required: false, default: 'Error' },
    errorMessage: { type: String, required: false, default: '' }
  },
  emits: ["fileSelected", "fileRemoved", "uploadProgressComplete", "fileError"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'fileSelected', file: File): void
  (e: 'fileRemoved'): void
  (e: 'uploadProgressComplete'): void
  (e: 'fileError', error: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { accept: string, maxFileSize: number, dragDropText: string, fileTypesText: string, uploadStatusText: string, errorStatusText: string, errorMessage: string };





// Estado reactivo
const fileInput = ref<HTMLInputElement>()
const isDragOver = ref(false)
const uploadedFile = ref<File | null>(null)
const uploadProgress = ref(0)
const hasErrorMessage = computed(() => props.errorMessage)

// Métodos para drag and drop
function onDragOver(event: DragEvent) {
  event.preventDefault()
  isDragOver.value = true
}

function onDragLeave(event: DragEvent) {
  event.preventDefault()
  isDragOver.value = false
}

function onDrop(event: DragEvent) {
  event.preventDefault()
  isDragOver.value = false

  const files = event.dataTransfer?.files
  if (files && files.length > 0) {
    handleFileSelection(files[0])
  }
}

function triggerFileInput() {
  fileInput.value?.click()
}

function onFileSelect(event: Event) {
  const target = event.target as HTMLInputElement
  const files = target.files
  if (files && files.length > 0) {
    handleFileSelection(files[0])
  }
}

function handleFileSelection(file: File) {
  uploadedFile.value = file
  uploadProgress.value = 0

  // Si no hay error, simular progreso de subida
  simulateUploadProgress()

  // Emitir evento
  emit('fileSelected', file)
}

function simulateUploadProgress() {
  const interval = setInterval(() => {
    uploadProgress.value += Math.random() * 15 + 5

    if (uploadProgress.value >= 100) {
      uploadProgress.value = 100
      emit('uploadProgressComplete', uploadProgress.value)
      clearInterval(interval)
    }
  }, 200)
}

function removeUploaderFile(): void {
  uploadedFile.value = null
  uploadProgress.value = 0

  // Limpiar el input
  if (fileInput.value) {
    fileInput.value.value = ''
  }

  emit('fileRemoved')
}


return { __sfc: true,props, emit, fileInput, isDragOver, uploadedFile, uploadProgress, hasErrorMessage, onDragOver, onDragLeave, onDrop, triggerFileInput, onFileSelect, handleFileSelection, simulateUploadProgress, removeUploaderFile, formatBytes }
}

})